import { BidApi } from 'api-typings/projects/projects';
import { _transformBid } from '../bids';
import { ProjectViewBid } from './project-view-bids.model';

export function transformProjectViewBids(
  projectViewBid: BidApi,
  recommendedBid?: BidApi,
): ProjectViewBid {
  return {
    ..._transformBid(projectViewBid),
    score:
      projectViewBid.score !== undefined
        ? projectViewBid.score
        : Number.NEGATIVE_INFINITY,
    recommended: !!recommendedBid && recommendedBid.id === projectViewBid.id,
  };
}
